<template>
  <div>
    <SourceSelect
      :model-value="currentSource"
      @update:modelValue="selectSource"
      :trigger-class="triggerClass"
      :locked="isPosMode"
    />
  </div>
</template>

<script setup lang="ts">
import { type RefSourceDto } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import type { ClassValue } from 'vue';
import { useI18n } from 'vue-i18n';
import { useConfirmDialog } from '../../composables/dialog/useConfirmDialog';
import { usePos } from '../../stores/posStore.ts';
import { useSource } from '../../stores/sourceStore';
import SourceSelect from './SourceSelect.vue';

withDefaults(
  defineProps<{
    triggerClass?: ClassValue;
  }>(),
  {
    triggerClass: 'btn btn-neutral py-6',
  },
);
const { t } = useI18n();
const { currentSource } = useSource();
const { isPosMode } = usePos();
const { show: showConfirmDialog } = useConfirmDialog();

const selectSource = async (source: RefSourceDto | null) => {
  if (
    currentSource.value?.id === source?.id ||
    !(await showConfirmDialog({
      title: `Switch to Source: ${source?.name ?? t('source.global')}`,
      message: `Are you sure you want to switch to source "${source?.name ?? t('source.global')}${source?.description ? `(${source.description})` : ''}?`,
      confirmText: 'Switch',
      cancelText: 'Cancel',
    }))
  )
    return;

  currentSource.value = source;
};
</script>
